<!--Author: Michał Pawłowski-->
<template>
  <div class="common-search-bar shadow-sm border rounded bg-white p-2 mb-3">
    <div class="row g-2 align-items-center">

      <div class="col-12 col-md-4 col-lg-3">
        <div class="input-group">
          <span class="input-group-text bg-light-gray border-end-0 text-secondary">
            <i class="fas fa-filter small"></i>
          </span>

          <select
              v-model="fieldKeyToSearch"
              class="form-select border-start-0 ps-1 text-secondary fw-medium"
              name="search-option-radio"
              style="cursor: pointer;"
          >
            <option value="" selected disabled hidden>{{ selectSearchFieldText }}</option>
            <option
                v-for="option in searchOptions"
                :key="option.key"
                :value="option.key"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-12 col-md-8 col-lg-9">
        <div class="input-group">
          <input
              v-on:keydown.enter="runSearch"
              id="search-text-input"
              ref="search-text-input"
              type="text"
              class="form-control"
              :class="{'bg-light': !searchBarActive}"
              placeholder="Szukaj frazy..."
              v-model="phraseToSearch"
              :disabled="!searchBarActive"
              autocomplete="off"
          />

          <button
              class="btn btn-primary d-flex align-items-center gap-2 px-3"
              @click="runSearch"
              :disabled="!searchBarActive"
              title="Uruchom wyszukiwanie"
          >
            <i class="fas fa-search"></i>
            <span class="d-none d-sm-inline">Szukaj</span>
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBarComponent2",
  components: {},
  props: {
    searchOptions: Array,
    defaultSearchField: {
      type: String,
      required: false,
    }
  },
  emits: ["searchRequest"],
  data() {
    return {
      fieldKeyToSearch: "",
      phraseToSearch: "",
      selectSearchFieldText: "Wybierz kryterium...",
      searchBarActive: false,
    };
  },
  computed: {},
  methods: {
    runSearch() {
      var searchRequestPayload = {
        searchPhrase: this.phraseToSearch,
        searchKey: this.fieldKeyToSearch,
      };
      this.$emit("searchRequest", searchRequestPayload);
    },
    setSearchField(searchOptions) {
      if (this.defaultSearchField != null && this.defaultSearchField !== "" && this.defaultSearchField !== undefined) {
        console.log("Default key provided: ", this.defaultSearchField);
        // check if default key is in searchOptions
        let found = searchOptions.find(option => option.key === this.defaultSearchField);
        if (found !== undefined) {
          this.fieldKeyToSearch = this.defaultSearchField;
        } else {
          // if not, set first key as default
          if (searchOptions.length > 0) {
            this.fieldKeyToSearch = searchOptions[0].key;
          }
        }
      } else {
        // if no default key is provided, set first key as default

        console.log("No default key provided, setting first key as default: ", searchOptions);
        if (searchOptions.length > 0) {
          this.fieldKeyToSearch = searchOptions[0].key;
        }
      }
    },
  },
  watch: {
    fieldKeyToSearch: {
      handler(newValue) {
        if (newValue !== "" && newValue !== null && newValue !== this.selectSearchFieldText) {
          this.searchBarActive = true;
          // Opcjonalnie: Auto-focus na input po wybraniu kategorii (UX improvement)
          this.$nextTick(() => {
            if (this.$refs['search-text-input']) this.$refs['search-text-input'].focus();
          });
        } else {
          this.searchBarActive = false;
        }
      },
      deep: true,
    },
    searchOptions: {
      handler(newValue) {
        this.setSearchField(newValue);
      },
      deep: true,
    },
  },
  mounted() {
    this.setSearchField(this.searchOptions);

  }
};
</script>

<style scoped>
/* --- Font & Colors (Consistent with CommonTable2) --- */
.common-search-bar {
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif;
  font-size: 0.875rem; /* 14px */
  color: #2b2b2b;
  transition: all 0.2s ease;
}

/* Tło dla ikon w input-group */
.bg-light-gray {
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

/* Style formularzy nadpisujące Bootstrapa dla "SaaS look" */
.form-control, .form-select {
  border-color: #dee2e6;
  font-size: 0.875rem;
  padding: 0.5rem 0.75rem; /* Standardowa wysokość ~38px */
  box-shadow: none !important; /* Usunięcie domyślnego cienia BS */
}

/* Aktywny stan inputów - Brand Blue */
.form-control:focus, .form-select:focus {
  border-color: #0078D4;
  box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.1) !important;
  z-index: 2;
}

/* Select po lewej stronie - usunięcie zaokrąglenia po prawej, aby połączyć z ikoną */
.input-group-text {
  background-color: #fff;
  border-color: #dee2e6;
}

/* Przycisk szukania */
.btn-primary {
  background-color: #0078D4;
  border-color: #0078D4;
  font-weight: 500;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #005a9e; /* Ciemniejszy odcień przy hover */
  border-color: #005a9e;
}

.btn-primary:disabled {
  background-color: #a6cbf3;
  border-color: #a6cbf3;
}

/* Disabled input state */
.form-control:disabled {
  background-color: #f3f2f1;
  cursor: not-allowed;
}
</style>